import { useRef } from "react";
import { fetchQuota, sendUsage } from "utils/freemium";

// Feature keys that have both a `sendUsage("...")` entry and a
// `quota.{key}.available` field. Adding a new quota-backed activity? Add
// the key here and the page can just call `useQuotaActivity("newKey")`.
type QuotaActivityFeature = "bedtimeStories" | "readAlongs" | "bedtimeMeditations";

export type UseQuotaActivityResult = {
  // Records one play, then re-reads quota. Resolves to `{ exhausted: true }`
  // when the parent has hit their quota for `featureName` and the player
  // should close the webview on next dismissal. Stubbable via
  // `di={{ useVm }}` so storybook doesn't POST `/api/beyond/usage` or
  // GET `/api/beyond/quota`.
  recordUsage: () => Promise<{ exhausted: boolean }>;
};

export function useQuotaActivity(featureName: QuotaActivityFeature): UseQuotaActivityResult {
  const ref = useRef<UseQuotaActivityResult>();
  if (!ref.current) {
    ref.current = {
      recordUsage: async () => {
        await sendUsage(featureName);
        const quota = await fetchQuota();
        return { exhausted: !quota[featureName].available };
      },
    };
  }
  return ref.current;
}
